import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 18 21.81"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M17.69 13.06c-.4-.36-1.04-.36-1.45 0l-6.2 5.53V.95C10.04.42 9.57 0 9 0S7.96.43 7.96.95v17.64l-6.2-5.53c-.41-.36-1.04-.36-1.45 0-.2.18-.31.43-.31.69s.11.5.31.68l7.96 7.11s.07.05.12.08c.06.04.13.09.22.12.13.05.26.07.39.07s.26-.02.39-.07c.09-.03.16-.08.24-.14.02 0 .08-.05.1-.06l7.96-7.11c.2-.18.31-.42.31-.68s-.11-.5-.31-.68Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }